import React, { useState } from "react";
import { CheckInBadge, CheckInLocationBadge } from "src/components/CheckIn/CheckInBadges";
import { BadgeRow } from "src/components/CheckIn/CheckInControls.styled";
import { CheckInMapModal } from "src/scenes/Noticeboard/components/CheckInSection";
import { CheckedInAction } from "src/components/CheckedIn/CheckedInSiteStyles";
import { checkedInColors } from "src/components/CheckedIn/CheckedInStyles";
import { CheckIn } from "./viewerApi";

interface ViewerCheckInProps {
    checkIn: CheckIn;
    detail: boolean;
    busy: boolean;
    onToggle: () => void;
}

export function ViewerCheckIn({ checkIn, detail, busy, onToggle }: ViewerCheckInProps): React.ReactElement {
    const [mapOpen, setMapOpen] = useState<boolean>(false);
    return <>
        <BadgeRow style={{ marginTop: "16px", flexWrap: "nowrap" }}>
            <CheckInBadge category={checkIn.category} textColor={checkedInColors.black} />
            <CheckInLocationBadge placeName={checkIn.placeName} textColor={checkedInColors.black}
                onClick={() => setMapOpen(true)} />
        </BadgeRow>
        {detail && <>
            <p aria-live="polite">{checkIn.userCheckInsCount} {checkIn.userCheckInsCount === 1
                ? "user has" : "users have"} checked in here</p>
            <p>Have you been to this location?</p>
            <CheckedInAction type="button" $monochrome disabled={busy} aria-pressed={checkIn.hasUserCheckedIn}
                aria-label={checkIn.hasUserCheckedIn ? "Remove check in" : "Check In"} onClick={onToggle}>
                {busy ? "Updating…" : checkIn.hasUserCheckedIn ? "Checked In ✓" : "Check In"}
            </CheckedInAction>
        </>}
        <CheckInMapModal open={mapOpen} onClose={() => setMapOpen(false)} checkIn={checkIn} />
    </>;
}
